/* UNSCRIPTED funnel layer: attribution, checkout-mode experiment, tier dispatcher, storefront events.
   - No purchase events here: checkout lifecycle belongs to Shopify Customer Events / Web Pixels.
   - Persistent storage only when Shopify Customer Privacy allows analytics; otherwise session-only.
   - Never calls /cart/clear.js. Direct mode updates the existing cart (replaces only other tier lines) and then goes to checkout.
     A cart permalink is used only as a fallback because it replaces the whole cart.
   - Ad URLs may carry ?angle=<name> (for example angle=pager_sev1). It is stored with first and last touch and written to cart/order attributes. */
(function () {
  if (window.UnscriptedFunnel) return;
  var KEY = 'um_funnel_v1', DAYS = 30;

  function consent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }
  function read() {
    var o = {};
    try {
      var s = window.localStorage.getItem(KEY) || window.sessionStorage.getItem(KEY);
      if (s) o = JSON.parse(s) || {};
    } catch (e) { o = {}; }
    if (o.exp && o.exp < Date.now()) o = {};
    return o;
  }
  function write(o) {
    try {
      if (consent()) {
        o.exp = Date.now() + DAYS * 864e5;
        window.localStorage.setItem(KEY, JSON.stringify(o));
        window.sessionStorage.removeItem(KEY);
      } else {
        delete o.exp;
        window.sessionStorage.setItem(KEY, JSON.stringify(o));
        window.localStorage.removeItem(KEY);
      }
    } catch (e) {}
  }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function qs() { try { return new URLSearchParams(location.search); } catch (e) { return { get: function () { return null; } }; } }

  function angle() {
    var p = location.pathname.replace(/\/$/, ''), v = (qs().get('view') || '').replace('unscripted-', '');
    var map = { '/pages/deal-room': 'dealmaker', '/pages/exam-rounds': 'exam_clinical', '/pages/analog-recall': 'analog', '/pages/rooms': 'rooms', '/pages/quiz-recall-test': 'recall_test', '/pages/spatial-recall-test': 'recall_test', '': 'home' };
    if (map.hasOwnProperty(p)) return map[p];
    if (p.indexOf('/products/') === 0) return v || 'universal';
    return 'other';
  }

  function captureTouch() {
    var d = read(), q = qs(), a = angle();
    if (a === 'other') return;
    var prev = d.last || {};
    var t = {
      angle: a,
      ad_angle: q.get('angle') || prev.ad_angle || '',
      campaign: q.get('utm_campaign') || prev.campaign || '',
      content: q.get('utm_content') || prev.content || '',
      ad_id: q.get('ad_id') || prev.ad_id || '',
      source: q.get('source') || q.get('utm_source') || prev.source || '',
      url: location.pathname + (q.get('view') ? '?view=' + q.get('view') : '')
    };
    if (!d.first) d.first = t;
    d.last = t;
    write(d);
  }

  function bucket(mode, split) {
    var q = qs().get('checkout_mode');
    if (q === 'direct' || q === 'drawer') return q; /* QA override only */
    if (mode === 'direct' || mode === 'drawer') return mode;
    var d = read();
    if (d.exp_checkout === 'direct' || d.exp_checkout === 'drawer') return d.exp_checkout;
    var pct = isFinite(split) ? split : 50;
    d.exp_checkout = Math.random() * 100 < pct ? 'direct' : 'drawer';
    write(d);
    return d.exp_checkout;
  }

  function attrs(ctx, src, mode) {
    var d = read(), f = d.first || {}, l = d.last || {};
    var a = {
      funnel_angle: ctx || angle(),
      ad_angle: l.ad_angle || f.ad_angle, first_touch_ad_angle: f.ad_angle,
      first_touch_angle: f.angle, last_touch_angle: l.angle,
      first_touch_campaign: f.campaign, last_touch_campaign: l.campaign,
      first_landing_url: f.url, last_landing_url: l.url,
      ad_id: l.ad_id || f.ad_id, creative_id: l.content || f.content,
      landing_variant: ctx, entry_source: src || l.source,
      experiment_checkout_v1: mode, experiment_bump_v1: 'drawer'
    };
    var o = {};
    Object.keys(a).forEach(function (k) { if (a[k]) o[k] = String(a[k]); });
    return o;
  }

  function track(name, payload) {
    payload = payload || {};
    payload.angle = angle();
    var l = read().last || {};
    if (l.ad_angle) payload.ad_angle = l.ad_angle;
    payload.page = location.pathname;
    try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name, payload); } catch (e) {}
  }

  function post(path, body) {
    return fetch(root() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'request failed'); e.status = r.status; throw e; } return j; }); });
  }
  function showErr(w, msg) {
    var e = w.querySelector('.um-offer__err');
    if (e) { e.textContent = msg; e.hidden = false; }
  }

  function openDrawer(data) {
    var dr = document.querySelector('cart-drawer');
    if (!dr) { location.href = root() + 'cart'; return; }
    try { if (data && data.sections && dr.renderContents) dr.renderContents(data); } catch (e) {}
    try { dr.classList.remove('is-empty'); if (dr.open) dr.open(); } catch (e) { location.href = root() + 'cart'; }
  }

  function select(btn) {
    var w = btn.closest('[data-um-offer]'); if (!w) return;
    var id = btn.getAttribute('data-variant-id'), qty = parseInt(btn.getAttribute('data-qty') || '1', 10) || 1;
    var ctx = w.getAttribute('data-context'), src = w.getAttribute('data-source');
    var mode = bucket(w.getAttribute('data-mode'), parseInt(w.getAttribute('data-split'), 10));
    var a = attrs(ctx, src, mode);
    var err = w.querySelector('.um-offer__err'); if (err) err.hidden = true;
    track('unscripted_tier_selected', { tier: btn.getAttribute('data-tier'), variant_id: id, mode: mode, source: src, context: ctx });

    w.classList.add('is-loading');
    var tierIds = (w.getAttribute('data-tier-ids') || '').split(',');
    var dr = document.querySelector('cart-drawer');
    var secs = (dr && dr.getSectionsToRender) ? dr.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
    fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var has = false, remove = {};
      cart.items.forEach(function (it) {
        if (String(it.variant_id) === String(id)) has = true;
        else if (tierIds.indexOf(String(it.variant_id)) > -1) remove[String(it.variant_id)] = 0;
      });
      var chain = Promise.resolve();
      if (Object.keys(remove).length) chain = chain.then(function () { return post('cart/update.js', { updates: remove }); });
      if (!has) chain = chain.then(function () { return post('cart/add.js', { items: [{ id: parseInt(id, 10), quantity: qty }] }); });
      return chain;
    }).then(function () {
      return post('cart/update.js', { attributes: a, sections: secs });
    }).then(function (data) {
      w.classList.remove('is-loading');
      if (mode === 'direct') { location.href = root() + 'checkout'; return; }
      openDrawer(data);
    }).catch(function (e) {
      w.classList.remove('is-loading');
      if (mode === 'direct' && !(e && e.status === 422)) {
        /* Fallback only: a cart permalink replaces the whole cart. */
        var q = Object.keys(a).map(function (k) { return 'attributes[' + encodeURIComponent(k) + ']=' + encodeURIComponent(a[k]); }).join('&');
        location.href = root() + 'cart/' + id + ':' + qty + (q ? '?' + q : '');
        return;
      }
      showErr(w, e && e.status === 422 ? 'That option is not available right now. Please choose another.' : 'We could not update your cart. Please try again.');
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-um-tier]');
    if (b && !b.disabled) { e.preventDefault(); select(b); }
  });

  /* Storefront events */
  var fired = {};
  function onScroll() {
    var h = document.documentElement, pct = ((window.scrollY || h.scrollTop) + window.innerHeight) / Math.max(h.scrollHeight, 1) * 100;
    [25, 50, 75].forEach(function (t) { if (pct >= t && !fired[t]) { fired[t] = 1; track('unscripted_scroll_' + t); } });
  }
  function init() {
    captureTouch();
    window.addEventListener('scroll', onScroll, { passive: true });
    if ('IntersectionObserver' in window) {
      var seen = {};
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) {
            var el = en.target, k = el.getAttribute('data-source') + ':' + (el.id || '');
            if (!seen[k]) { seen[k] = 1; track('unscripted_order_module_view', { source: el.getAttribute('data-source'), context: el.getAttribute('data-context') }); }
          }
        });
      }, { threshold: 0.4 });
      document.querySelectorAll('[data-um-offer]').forEach(function (el) { io.observe(el); });
    }
    /* Bump events (best effort: bump block renders inside the cart drawer) */
    var bumpSeen = false;
    new MutationObserver(function () {
      var dr = document.querySelector('cart-drawer');
      if (!bumpSeen && dr && /Add to your order/i.test(dr.textContent || '') && dr.querySelector('input[type=checkbox]')) { bumpSeen = true; track('unscripted_bump_view'); }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.type === 'checkbox' && t.checked && t.closest && t.closest('cart-drawer') && /Deployment Pack/i.test(t.closest('cart-drawer').textContent || '')) track('unscripted_bump_added');
    });
    document.addEventListener('visitorConsentCollected', function () { var d = read(); write(d); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.UnscriptedFunnel = { select: select, attrs: attrs, track: track, bucket: bucket, angle: angle };
})();